export default (numRows, groups) => {
  let result = [];
  for (let i = 0; i < numRows; i+=1) {
    result.push(groups[Object.keys(groups)[i]].from + ((numRows - i - 1) * 2 + 1));
  }
  return result;
}
